var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-toolbar',[_vm._t("actions",null,{"actionStyle":"margin-right: 15px"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }